import { splitShipmentLocationGroupsViewSchema } from "@redotech/redo-fulfillment-settings/split-shipment-location-groups";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getSplitShipmentLocationGroups = unaryRpc({
  name: "getSplitShipmentLocationGroups" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: splitShipmentLocationGroupsViewSchema,
});
